import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { BarChart } from '@mui/x-charts/BarChart';

import useNotification from '../../../core/hooks/use_notification';
import { getSalesByPodAction, getSalesByPodState } from '../../../features/stats/get_sales_by_pod';
import { getSalesStatsNotificationData } from '../../../core/utils/notification_utils';
import { formatCompactCurrency, formatCurrency, formatNumber, getPodLabel, truncateLabel, useChartColors } from './sales_analysis_utils';
import ChartCard from './chart_card';

const ROW_HEIGHT = 34;

const PodRankingChart = ({ query, pods }) => {
    const chartColors = useChartColors();
    const dispatch = useDispatch();
    const { showErrorMessage } = useNotification();
    const getSalesByPod = useSelector(getSalesByPodState);

    useEffect(() => {
        dispatch(getSalesByPodAction(query))
            .then(response => showErrorMessage(getSalesStatsNotificationData(response)));
    }, [dispatch, query, showErrorMessage]);

    const dataset = (getSalesByPod?.data || []).map(row => ({
        label: getPodLabel(pods, row?.podId),
        revenue: Number(row?.revenue),
        orders: row?.orders
    }));

    return (
        <ChartCard
            title="Ranking punktów sprzedaży"
            subtitle="Obrót brutto w wybranym okresie"
            loading={ getSalesByPod?.loading }
            empty={ dataset.length === 0 }
            height={ Math.max(120, dataset.length * ROW_HEIGHT + 48) }
        >
            {
                dataset.length > 0 && (
                    <BarChart
                        layout="horizontal"
                        dataset={ dataset }
                        series={ [{
                            dataKey: 'revenue',
                            label: 'Obrót',
                            color: chartColors.primary,
                            valueFormatter: (value, { dataIndex }) => `${ formatCurrency(value) } · ${ formatNumber(dataset[dataIndex]?.orders) } transakcji`
                        }] }
                        yAxis={ [{ scaleType: 'band', dataKey: 'label', valueFormatter: (label, context) => context.location === 'tick' ? truncateLabel(label) : label }] }
                        xAxis={ [{ valueFormatter: formatCompactCurrency, tickNumber: 5 }] }
                        grid={ { vertical: true } }
                        borderRadius={ 4 }
                        margin={ { left: 220, right: 40, top: 8, bottom: 32 } }
                        slotProps={ { legend: { hidden: true } } }
                    />
                )
            }
        </ChartCard>
    );
};

export default PodRankingChart;
